// utils/notificationUtils.ts

import { message } from "antd";

export const successMessage = (text: string, duration = 4) => {
  message.open({
    type: "success",
    content: text,
    duration: duration,
  });
};
export const errorMessage = (text: string, duration = 4) => {
  message.open({
    type: "error",
    content: text,
    duration: duration,
  });
};

export const warningMessage = (text: string, duration = 4) => {
  message.open({
    type: "warning",
    content: text,
    duration: duration,
  });
};

export const dischargeSummaryMessage = (text: string, duration = 4) => {
  message.open({
    type: 'warning',
    content: text,
    className: 'custom-class',
    duration: duration,
    style: {
      marginTop: '20vh',
      fontSize: "16px"
    },
  });
};